import React, { useEffect, useRef } from "react";

// SASS
import "./Part2.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS

// FUNCTION EXPORT
export default function Part2({
  step,
  setShowVirusParts,
  setCurrentVirusPart,
}) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "2", height: null, description: "spacer" },
    {
      stepNumber: "3",
      height: null,
      description: "change background color to 003366 on exit",
      offset: 0,
    },
  ];

  // REFS

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "3": {
            animate.changeBodyBgColorUp("#FFFFFF", direction);
            if (direction === "up") setShowVirusParts(false);
            if (direction === "up") setCurrentVirusPart(null);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "3": {
            if (direction === "down") setShowVirusParts(true);

            setTimeout(() => {
              if (direction === "down") setCurrentVirusPart("genes");
              animate.changeBodyBgColorDown("#003366", direction);
            }, 0);

            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part2">
          <div className="part2__text part2__text--top">
            Viruses are made up of:
          </div>
          <div className="part2__section-label part2__section-label--genes">
            GENES
          </div>
          <div className="part2__section-label part2__section-label--proteins">
            PROTEINS
          </div>
          <div className="part2__section-label part2__section-label--envelope">
            ENVELOPE
          </div>
          <div className="part2__text part2__text--bottom">
            Let’s go through each part.
          </div>
          <div className="part2__line"></div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
